import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PlatformWorkerStrategy } from './PlatformWorkerStrategy';
const createDeduplicateScope = () => {
  let promise = null;
  return async fn => {
    if (!promise) {
      promise = fn();
    }
    return promise;
  };
};
export class SingleWorkerStrategy extends PlatformWorkerStrategy {
  constructor(workerUrl, limitedPrivateAPI, events) {
    super(limitedPrivateAPI, events);
    this.workerUrl = workerUrl;
    this.limitedPrivateAPI = limitedPrivateAPI;
    this.events = events;
    _defineProperty(this, "workerAPI", undefined);
    _defineProperty(this, "spawnWorkerDeduplicator", createDeduplicateScope());
  }
  async getWorkerAPI() {
    if (this.workerAPI) {
      return this.workerAPI;
    }
    const workerAPI = await this.spawnWorkerDeduplicator(() => this.spawnWorker(this.workerUrl));
    this.workerAPI = workerAPI;
    return workerAPI;
  }
  forEachWorker(cb) {
    if (this.workerAPI) {
      cb(this.workerAPI);
    }
  }
}
//# sourceMappingURL=SingleWorkerStrategy.js.map